import React from 'react';
import { Grid } from '@material-ui/core';
import { Text } from 'library';

export default function Confirmation({ large = false }: { large?: boolean }) {
    return (
        <Grid container direction="column">
            <Grid item>
                <Text variant={large ? 'h1' : 'body1'}>Got it! We will let you know when this is available.</Text>
            </Grid>
        </Grid>
    );
}
